import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FusePageCarded } from '@fuse';
import { Icon, Button, IconButton, Tooltip } from '@material-ui/core';
import ReactTable from "react-table";
import * as Actions from './store/actions';
import * as TableActions from 'main/components/tableSort/store/actions';
import * as NavActions from '../../components/paramHistory/store/actions';
import _ from 'lodash';
import TabPanelButtons from '../../components/TabPanelButtons';
import * as HelperFunctions from '../../components/helpers'; 
import PageHeader from 'main/components/PageHeader';

const styles = theme => ({
    layoutRoot: {},
});

class StudentList extends Component {

    componentDidMount() {
        this.props.getStudentList();
    }

    handleRowClick(page_type, student_id) {
        this.props.history.push(`/student/${page_type}/${student_id}`);
    }

    handleAddNew = () => {
        this.props.updateAuthPreloadRole({ active: true, role: { RoleName: 'Student', role_id: 4 } })
        return this.props.history.push("/user/create")
    }

    render() {
        const { classes, studentList, table_sort, table_filter, table_page_size, is_loaded } = this.props;
        const table_name = this.constructor.name;

        if (!is_loaded) return <React.Fragment>Loading...</React.Fragment>;

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <PageHeader
                        component_type = {"student"}
                        view_type      = {"list"}
                    />
                }
                contentToolbar={
                    <div className="px-24 flex flex-1 justify-end">
                        <TabPanelButtons
                            component_name = {"student"}
                            view_type      = {"list"}
                            button_list    = {[
                                {
                                    display: "Add",
                                    type:    "create",
                                    color:   "primary",
                                    onClick: () => this.handleAddNew(),
                                }
                            ]}
                        />
                    </div>
                }
                content={
                    <ReactTable
                        style={{ position: 'absolute' }}
                        columns={[
                            {
                                Header: "First Name",
                                accessor: "FirstName"
                            },
                            {
                                Header: "Last Name",
                                accessor: "LastName"
                            },
                            {
                                Header: "Email",
                                accessor: "Email",
                            },
                            {
                                Header: "Actions",
                                maxWidth: 150,
                                Cell: row => (
                                    <div className="flex items-center">
                                        <Tooltip title="Detail">
                                            <IconButton
                                                style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    this.handleRowClick('detail', row.original.student_id);
                                                }}
                                            >
                                                <Icon>library_books</Icon>
                                            </IconButton>
                                        </Tooltip>
                                        {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "student", "edit") ? null :
                                            <Tooltip title="Edit">
                                                <IconButton
                                                    style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        this.handleRowClick('edit', row.original.student_id);
                                                    }}
                                                >
                                                    <Icon>border_color</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        }
                                    </div>
                                )
                            }
                        ]}
                        data={studentList}
                        defaultPageSize={25}
                        pageSize={table_page_size[table_name]}
                        className="-striped -highlight"
                        noDataText="No Students Found"
                        defaultSorted={table_sort[table_name]}
                        onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                        filterable={true}
                        defaultFiltered={table_filter[table_name]}
                        onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
                        onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                    />
                }
            />   
        );
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        getStudentList:        Actions.getStudentList,
        setTableSort:          TableActions.setTableSort,
        setTableFilter:        TableActions.setTableFilter,
        setTablePageSize:      TableActions.setTablePageSize,
        updateAuthPreloadRole: NavActions.updateAuthPreloadRole
    }, dispatch);
}

function mapStateToProps({ studentApp, tableSort, auth })
{
    return {
        studentList:     studentApp.students.studentList,
        table_sort:      tableSort.table_sort,
        table_filter:    tableSort.table_filter,
        table_page_size: tableSort.table_page_size,
        is_loaded:       tableSort.is_loaded,
        auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(StudentList)));


// WEBPACK FOOTER //
// src/main/content/student/StudentList.js